import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-table-delete-button',
    templateUrl: './table-delete-button.component.html',
    styleUrls: ['./table-delete-button.component.css'],
    standalone: false
})
export class TableDeleteButoonComponent {

  @Input()
  imageSrc!: string;
  @Input()
  tooltip!: string;
  @Input() color: string = 'primary';
  @Output() buttonClick = new EventEmitter<void>();

  onClick() {
    this.buttonClick.emit();
  }

}
